import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/auth'

// firebase init
const config = {
    apiKey: "AIzaSyC44_h3Z_GWS4vJAIgvyDgAgNX362w9eG4",
    authDomain: "wordbywordapp.firebaseapp.com",
    databaseURL: "https://wordbywordapp.firebaseio.com",
    projectId: "wordbywordapp",
    storageBucket: "wordbywordapp.appspot.com",
    messagingSenderId: "339736194572"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const messaging = firebase.messaging()
const auth = firebase.auth()
const currentUser = auth.currentUser
//console.log(messaging)

// date issue fix according to firebase
const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const wordsCollection = db.collection('words')
const ideasCollection = db.collection('ideas')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    wordsCollection,
    ideasCollection,
    messaging
}
